// src/components/Dashboard/DashboardHeader.jsx
import React from "react";
import { Menu, Bell, LogOut, RefreshCw } from "lucide-react";

const DashboardHeader = ({
  userName,
  funcao,
  handleLogout,
  toggleSidebar,
  isMobile,
  onRefresh,
}) => {
  return (
    <header className="bg-white shadow-sm z-10">
      <div className="flex items-center justify-between md:justify-end px-4 py-3">
        {isMobile && (
          <button
            onClick={toggleSidebar}
            className="p-2 rounded-lg hover:bg-gray-100 md:hidden"
          >
            <Menu className="w-6 h-6 text-gray-600" />
          </button>
        )}
        <div className="flex items-center space-x-4">
          <button className="p-2 rounded-lg hover:bg-gray-100 relative hidden">
            <Bell className="w-5 h-5 md:w-6 md:h-6 text-gray-600" />
            <span className="absolute top-1 right-1 w-2 h-2 bg-red-500 rounded-full"></span>
          </button>
          <div className="flex items-center space-x-2">
            <div className="flex flex-col">
              <span className="text-sm text-gray-700 hidden md:block font-medium">
                {userName}
              </span>
              <span className="text-sm text-gray-700 hidden md:block text-right uppercase">
                {funcao}
              </span>
            </div>
            <button
              onClick={handleLogout}
              className="p-2 rounded-lg hover:bg-red-50 text-gray-600 hover:text-red-600 transition-colors"
            >
              <LogOut className="w-5 h-5" />
            </button>
          </div>
        </div>
      </div>
    </header>
  );
};

export default DashboardHeader;
